import { render } from "./App.vue?vue&type=template&id=2db9f1bc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2db9f1bc&lang=css"

import exportComponent from "D:\\mehboob\\flymall\\New folder\\updated6in1\\crashwinmakaz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__